<template>
  <div class="tbl-time-tasks">
    <div class="task" v-for="(task, index) in tasks" :key="index">
      <div :class="{'toggle': true, 'active': activeIndex == index}">
        <a :class="{'no-records': task.timesheets.length == 0 }" href="javascript:;" @click="toggleIndex( task.timesheets.length ? index : -1 )">{{ '#' + (task.seq_no?task.seq_no:task.id) + ' | ' + task.name }}</a>
      </div>
      <table-time-details-2 class="task-time" :job_name="job_name" :client_name="client_name" :records="task.timesheets" v-if="activeIndex == index"></table-time-details-2>
    </div>
  </div>
</template>

<script>
  import TableTimeDetails2 from './TableTimeDetails2.vue';
export default {
  components: {
    TableTimeDetails2
  },
  data () {
    return {
      activeIndex: -1
    }
  },
  props: ['tasks', 'client_name', 'job_name'],
  watch: {
    tasks ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.tasks = newVal;
      }
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    init () {

    },
    toggleIndex ( index ) {
      let self = this;
      self.activeIndex = (self.activeIndex == index) ? -1 : index;
    }
  }
}
</script>
